import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Vinculo Empregatício',
  path: '/pessoal/pesvinculoempregaticio',
  name: 'pesvinculoempregaticio',
  component: () => import('@/views/pessoal/pesvinculoempregaticio/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.VINCULOEMPREGATICIONOVO_MENU_1400700699],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Vinculo Empregatício',
  path: '/pessoal/pesvinculoempregaticio/cadastro/:id?',
  parent: 'pesvinculoempregaticio',
  name: 'pesvinculoempregaticio_create',
  component: () => import('@/views/pessoal/pesvinculoempregaticio/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.VINCULOEMPREGATICIONOVO_MENU_1400700699],
  },
  goesToMenu: true,
 },
]
